
import { mapGetters } from "vuex";
import TableApp from "@/components/Table/Table2";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import Pencil from "vue-material-design-icons/Pencil.vue";
import List from "vue-material-design-icons/ArrowRightThick.vue";
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "app-lista-banco",
  mixins: [SistemaMixin],
  components: {
    TableApp,
    TrashCanIcon,
    Pencil,
    List,
  },
  data() {
    return {
      fields: [
        {
          label: "Banco",
          field: "nome",
          type: "text",
          slot: true,
          sortable: true,
          width: "15%",
        },
        {
          label: "Saldo",
          field: "saldo",
          type: "text",
          slot: true,
          sortable: true,
          width: "15%",
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "10%",
          filterOptions: {
            enabled: false,
          },
        },
      ],
    };
  },
  methods: {
    excluirCliente(data) {
      this.getRequestAdmin(async() => {
        this.$swal
          .fire({
            icon: "warning",
            title: "Deseja  deletar o banco " + data.nome + "?",
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/bancos/delete", {
                id_banco: data.id_banco,
              });
              this.$refs.bancos.refresh();
              this.$toast.success("Banco excluído!");
            }
          });
      })
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
  },
  async mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
